import { StandardAlert } from '@brandfolder/react';
import React, { FunctionComponent } from 'react';

import { useFetch } from '@api/ApiHelper';
import { PlanGetResponse } from '@api/v4/resources/plan';
import { BFLoader } from '@components/common/loader/main';

import './styles/plan-limits.scss';

interface UserLimitProps {
  count: number;
  invitationCount: number;
  invitationsLabel: string;
  label: string;
  limit: number;
}

const UserLimit: FunctionComponent<UserLimitProps> = ({
  count,
  invitationCount,
  invitationsLabel,
  label,
  limit
}) => (
  <div className="user-limit">
    <div className="user-limit__count user-limit__count--users">
      <div>
        <span className="user-limit__count--big">{count}</span>
        {` / ${limit === -1 ? bfTranslate('unlimited') : limit}`}
      </div>
      <div>
        {label}
      </div>
    </div>
    <div className="user-limit__count user-limit__count--invitations">
      <div>
        <span className="user-limit__count--big">{invitationCount}</span>
      </div>
      <div>
        {invitationsLabel}
      </div>
    </div>
  </div>
);

export const PlanLimits: FunctionComponent = () => {
  const planLimitsFetch = useFetch<PlanGetResponse>({
    url: `/api/v4/${BFG.resource.type}s/${BFG.resource.key}/plan`,
    fields: 'limit_counts'
  });

  let planLimitsBody;

  if (planLimitsFetch.loading) {
    planLimitsBody = <BFLoader className="bulk-management-styling-exempt" />;
  } else if (planLimitsFetch.error) {
    planLimitsBody = (
      <StandardAlert
        className="plan-limits__warning-message"
        showHeading={false}
      >
        {bfTranslate("We were unable to retrieve information regarding your account's plan limits. Please try again or contact customer support.")}
      </StandardAlert>
    );
  } else if (planLimitsFetch.response) {
    planLimitsBody = (
      <>
        <UserLimit
          count={planLimitsFetch.response.data.attributes.limit_counts.collaborators}
          invitationCount={planLimitsFetch.response.data.attributes.limit_counts.collaborator_invites}
          invitationsLabel={bfTranslate('Pending Collaborator invitations')}
          label={bfTranslate('Collaborators on plan')}
          limit={planLimitsFetch.response.data.attributes.limits.collaborators}
        />
        <UserLimit
          count={planLimitsFetch.response.data.attributes.limit_counts.admins}
          invitationCount={planLimitsFetch.response.data.attributes.limit_counts.admin_invites}
          invitationsLabel={bfTranslate('Pending Admin/Owner invitations')}
          label={bfTranslate('Admins/Owners on plan')}
          limit={planLimitsFetch.response.data.attributes.limits.admins}
        />
      </>
    );
  }

  return (
    <div className="plan-limits">
      <h2>{bfTranslate('Plan Limits')}</h2>
      {planLimitsBody}
    </div>
  );
};